import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import EventIcon from "@material-ui/icons/Event";
import PlaceIcon from "@material-ui/icons/Place";
import { getFullDateDayName } from "@icarius-utils/date";
import { getAppColor } from "@icarius-app/selectors";
import { updateActivityAttemptFromSpecificTrainingAction } from "@icarius-pages/myTraining/actions";
import UpdateSessionAttemptDialog from "./updateSessionAttemptDialog";
import Container from "../../../container";

const InPersonAttemptsContent = (props) => {
    const { data, trainingData, activityData } = props;

    const [selectedAttemptIndexToUpdate, setSelectedAttemptIndexToUpdate] = useState(null);

    const dispatch = useDispatch();
    const color = useSelector(getAppColor);

    const handleSubmitUpdate = (dataToSend) => {
        dispatch(
            updateActivityAttemptFromSpecificTrainingAction(
                trainingData.id,
                activityData.id,
                selectedAttemptIndexToUpdate,
                dataToSend
            )
        );
    };

    if (!data?.length) return null;

    return (
        <>
            {data.map((attempt, attemptIndex) => {
                const attemptHasData = Boolean((attempt.date && attempt.time) || attempt.location);

                return (
                    <Container
                        key={attemptIndex}
                        title={`${getLocalizedString("attempt")} ${attemptIndex + 1} (${getLocalizedString(
                            "inPerson"
                        )})`}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                fontSize: 14,
                            }}
                        >
                            {!attemptHasData && (
                                <Typography>
                                    {getLocalizedString(
                                        !trainingData.isParticipant ? "noSessionDataShort" : "noSessionData"
                                    )}
                                </Typography>
                            )}
                            {Boolean(attempt.date && attempt.time) && (
                                <Typography
                                    style={{
                                        fontSize: 14,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 5,
                                    }}
                                >
                                    <EventIcon style={{ height: 20 }} /> {getFullDateDayName(attempt.date)} -{" "}
                                    {attempt.time} {getLocalizedString("hrs")}
                                </Typography>
                            )}
                            {Boolean(attempt.location) && (
                                <Typography
                                    style={{
                                        fontSize: "inherit",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 5,
                                    }}
                                >
                                    <PlaceIcon style={{ height: 20 }} />
                                    {attempt.location}
                                </Typography>
                            )}
                            {attempt.canUpdate && (
                                <Button
                                    onClick={() => setSelectedAttemptIndexToUpdate(attemptIndex)}
                                    variant="contained"
                                    className="whiteText"
                                    style={{ background: color, border: 0 }}
                                >
                                    {getLocalizedString("edit")}
                                </Button>
                            )}
                        </div>
                    </Container>
                );
            })}
            {selectedAttemptIndexToUpdate !== null && (
                <UpdateSessionAttemptDialog
                    open={selectedAttemptIndexToUpdate !== null}
                    data={data[selectedAttemptIndexToUpdate]}
                    isSession={false}
                    handleSubmit={handleSubmitUpdate}
                    handleClose={() => setSelectedAttemptIndexToUpdate(null)}
                />
            )}
        </>
    );
};

export default InPersonAttemptsContent;
